module.exports = __webpack_public_path__ + "static/media/fasaddoor.ca1889ce.jpeg";